import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DEFAULT_PAGE } from '~/utils/constants/jobs';
import { IJob } from '~/utils/interface/job';
import { handleGetAllEstimate, handleGetJobs } from './jobThunk';

export interface JobState {
  jobs: Array<IJob>;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  needRefreshData: boolean;
  showAddJobModal: boolean;

  //est
  jobEstimatesCurrentPage: number;
  jobEstimatesTotalPage: number;
  jobEstimatesTotalItems: number;
  jobEstimates: Array<any>,
  jobEstimatesFilter: any,
}

const initialState: JobState = {
  jobs: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  totalItems: 0,
  needRefreshData: false,
  showAddJobModal: false,

  //est
  jobEstimatesTotalPage: 0,
  jobEstimatesTotalItems: 0,
  jobEstimatesCurrentPage:DEFAULT_PAGE,
  jobEstimates:[],
  jobEstimatesFilter: {
    page : 1,
    limit: 10,
    textSearch: "",
  }
};

const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload;
    },
    setEstimateFilter(state, action:any) {
      state.jobEstimatesFilter = action.payload;
    },
    setShowAddJobModal(state, action: PayloadAction<boolean>) {
      state.showAddJobModal = action.payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetJobs.fulfilled, (state, action) => {
        state.jobs = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPage;
        state.totalItems = action.payload.pagination.totalItems;
        state.needRefreshData = false;
      })
      //est
      .addCase(handleGetAllEstimate.pending, (state) => {
        state.jobEstimates = [];
        // state.jobsLoading = false;
      })
      .addCase(handleGetAllEstimate.fulfilled, (state, action) => {
        let data = action.payload.data;
        state.jobEstimates = [...data.responses];
        state.jobEstimatesCurrentPage = data.pagination.page;
        state.jobEstimatesTotalPage = Math.ceil(data.pagination.totalItems / data.pagination.limit);
        state.jobEstimatesTotalItems = data.pagination.totalItems;
        // state.jobsLoading = false;
      })
  },
});

export const jobActions = jobSlice.actions;

const jobReducer = jobSlice.reducer;
export default jobReducer;
